import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '#pplx/frontend/aether/components/Button/index.js';
import { useAskInputExhaustedSearchMode } from '#pplx/frontend/apps/ask/ask-input/ask-input-attributions/hooks/useAskInputExhaustedSearchMode.js';
import { AskInputExhaustedSearchMode } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/components/AskInputExhaustedSearchMode.js';
import { AskInputSearchMode } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/components/AskInputSearchMode.js';
import { useSearchModeToggleSlotProps } from '#pplx/frontend/apps/ask/composer-sdk-plugins/search-mode-toggle/useSearchModeToggleSlotProps.js';
import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import { ModeToggleGroup } from '#pplx/frontend/composer-sdk-plugins/mode-toggle/ModeToggleGroup.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { useIntl } from 'react-intl';
function ExhaustedSearchModeStatus({ showSearchModeMenu, }) {
    const exhaustedSearchModeProps = useAskInputExhaustedSearchMode({
        showSearchModeMenu,
    });
    return exhaustedSearchModeProps.showExhaustedSearchMode ? (_jsx(AskInputExhaustedSearchMode, { ...exhaustedSearchModeProps })) : null;
}
export function SearchModeToggleSlot({ showExhaustedSearchMode = false, ...adapterProps }) {
    const { $t } = useIntl();
    // Ask's mode state, policy, menu, and subscription hooks are tightly coupled
    // inside useSearchModeToggleSlotProps. Until they are decoupled, keep that hook
    // in this slot so plugin registration is their shared mount boundary: surfaces
    // that omit the slot neither read mode providers nor subscribe to shared-model IPC.
    const slotProps = useSearchModeToggleSlotProps(adapterProps);
    if (slotProps === null) {
        return null;
    }
    switch (slotProps.kind) {
        case 'command-button':
            return (_jsx(Button, { rounded: true, icon: $icon('slash'), "aria-label": $t({
                    defaultMessage: 'Open commands',
                    description: 'Aria label for the composer slash command menu button',
                    id: 'dadf06eccd',
                }), "aria-expanded": slotProps.computerCommandMenu.open, size: "small", variant: "text", interactableVariant: "alt", onClick: () => slotProps.computerCommandMenu.onOpenChange(!slotProps.computerCommandMenu.open) }));
        case 'browser-status':
            return _jsx(AskInputSearchMode, { ...slotProps.searchModeMenuProps });
        case 'toggle-group':
            return (_jsxs(_Fragment, { children: [_jsx(ModeToggleGroup, { ...slotProps.modeToggleGroupProps }), showExhaustedSearchMode && (_jsx(ExhaustedSearchModeStatus, { showSearchModeMenu: slotProps.showSearchModeMenu }))] }));
        default:
            return assertUnreachableValue(slotProps);
    }
}
//# sourceMappingURL=SearchModeToggleSlot.js.map